// extracted by css-extract-rspack-plugin
module.exports =  {"documentDetails":"DocumentDetailsTab__documentDetails___pdaOe"};